export const navLinks = [
  { href: '/about', label: 'Our company' },
  { href: '/locations', label: 'Locations' },
  { href: '/contact', label: 'Contact' },
];
